import { of, pipe } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const reportEffectError = (action: (error: string | object) => any) =>
  pipe(
    catchError((error) => {
      console.error(error);
      return of(action({ error }));
    })
  );
